
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-announcement{
  font-family:var(--ff-dmsans);
  font-size:var(--fs-sm);
  display:flex;
  flex-direction:column;
  position:relative;
}

.se-announcement__image > div{
  height:100%;
}

.se-announcement__image img{
  width:100%;
  height:auto;
  aspect-ratio:3/1;
  object-fit:cover;
}

.se-announcement__content{
  display:flex;
  flex-direction:column;
  padding:2rem;
  gap:var(--spacing-5);
}

.se-announcement__title{
  color:var(--brand-primary-1);
}

@media (min-width: 768px){
  .se-announcement{
    flex-direction:row;
  }

  .se-announcement__image{
    flex-basis:50%;
  }

  .se-announcement__image img{
    height:100%;
  }

  .se-announcement__content{
    flex-basis:50%;
  }
}

@media (min-width: 1024px){
  .se-announcement__image{
    flex-basis:60%;
  }

  .se-announcement__content{
    flex-basis:40%;
  }
}

@media (min-width: 1280px){
  .se-announcement__image{
    flex-basis:67%;
  }
  .se-announcement__content{
    padding:2rem 3rem;
    flex-basis:33%;
  }
}
`;